<mat-toolbar *ngIf="showNavbar" style="color: #0F1A41; background-color: #fff; border-bottom: 1px solid #ebebeb;">

  <mat-toolbar-row style="position: sticky; top: 0;z-index: 100">
    <img style="height:30px;" src="/assets/images/swedavia-logo.svg" alt="Swedavia logo" />

    <div class="break-line"></div>

    <div class="system-title">
      <span class="system-name" matTooltip="{{version}} {{environmemt}}">BKS</span>
      <span class="airport-name">ARN</span>
    </div>

    <div class="break-section"></div>

    <span matTooltip="{{currentDate}}" style="font-weight:bold;text-align:center;color:black ; flex:1 1 auto">
      {{currentTime}}
    </span>

    <!-- Hotfix 5.1 Ignore rendering error sign and message in header  -->
    <!-- <div *ngIf="errorMessage != ''" class="break-section"></div>
    <button *ngIf="errorMessage != ''" style="cursor: pointer" mat-icon-button matTooltip={{getErrorMessage()}} (click)="reload()">
      <img src="/assets/images/error.svg" alt="Error" />
    </button> -->

    <div class="break-section"></div>

    <span *ngIf="isAuthenticated()" style="vertical-align:central;">
      <button mat-icon-button>
        <img data-cy=goToTransfer class="transfer-button-active" *ngIf="hasTransfers()" src="/assets/images/transfer_new.svg" matTooltip="Visa transfer" alt="Visa transfer" (click)="showTransfer()" />
        <img data-cy=goToTransfer class="transfer-button" *ngIf="!hasTransfers()" src="/assets/images/transfer_no_new.svg" matTooltip="Inga transfers" alt="Inga transfers" (click)="showTransfer()" />
      </button>
    </span>

    <div class="break-section"></div>

    <span *ngIf="isAuthenticated()" style="vertical-align:central;">
      <button mat-icon-button>
        <mat-icon class="green-icon" *ngIf="settings.sound" matTooltip="Ljud på" (click)="toggleSound()" matTooltipPosition="left">volume_up</mat-icon>
        <mat-icon class="green-icon" *ngIf="!settings.sound" matTooltip="Ljud av" (click)="toggleSound()" matTooltipPosition="left">volume_off</mat-icon>
      </button>
    </span>

    <div class="break-section"></div>

    <span *ngIf="isAuthenticated()" style="vertical-align:central;" (click)="showImportLogs()">
      <button mat-icon-button matTooltip={{lastImportToolTipText}}>
        <svg width="26" height="26" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path [ngClass]="[currentHeromaState]" d="M0 3.64391C1.70628 3.16423 5.93583 2.22635 10.7438 3.88016C13.39 4.7894 15.2915 6.16399 16.4772 7.18778C17.3303 5.94206 19.2607 3.46492 22.6878 1.74668C26.7366 -0.279416 30.4962 -0.064636 32 0.100029C31.7542 1.4961 30.9444 5.00418 27.944 8.16145C25.3339 10.9035 22.3986 11.9845 21.0176 12.3926C21.437 14.2111 21.8997 17.2968 21.2273 21.0125C20.6634 24.1196 19.5138 26.4965 18.6317 28C17.5472 27.1337 15.3855 25.1721 14.0696 21.9002C12.479 17.9411 13.0791 14.433 13.3755 13.1014C12.1536 13.1945 9.10981 13.2517 5.97198 11.4476C1.55445 8.91318 0.25305 4.57462 0 3.64391Z" />
        </svg>
        <small *ngIf="(unhandledLogs > 0)" class="notification-import-badge">{{unhandledLogs}}</small>
      </button>
    </span>

    <div class="break-section"></div>

    <span *ngIf="isAuthenticated()" style="vertical-align:central;">
      <button mat-icon-button>
        <mat-icon class="material-icons {{liveFlightStatusColor}}" aria-label="LiveFlight import status" matTooltip="{{liveFlightStatusText}}" matTooltipPosition="left">{{liveFlightStatusIcon}}</mat-icon>
      </button>
    </span>

    <div class="break-section"></div>

    <span *ngIf="isAuthenticated()" style="vertical-align:central;">
      <button mat-icon-button>
        <mat-icon aria-label="Connection" class="cloud-icon" matTooltip="{{hubConnectionStatusText}}" matTooltipPosition="left">{{hubConnectionStatusIcon}}</mat-icon>
      </button>
    </span>

    <div class="break-section"></div>

    <button class="menu-button" (click)="OCmenu()">
      <svg height="24" viewBox="0 0 68 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2_80)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M68 43.5556V49H0V43.5556H68ZM68 21.7778V27.2222H0V21.7778H68ZM68 0V5.44444H0V0H68Z" fill="#0A2744" />
        </g>
      </svg>
      <span class="menu-icon-text">Menu</span>
    </button>
    <div *ngIf="menustatus" class="menu-body">
      <div class="mask" (click)="OCmenu()"></div>
      <div class="list">
        <div class="top-section">
          <button class="menu-button" (click)="OCmenu()">
            <svg height="24" viewBox="0 0 103 103" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.588313 96.0477L96.0477 0.58831L102.412 6.95227L6.95227 102.412L0.588313 96.0477Z" fill="#1F2140" />
              <path d="M6.95227 0.588315L102.412 96.0477L96.0477 102.412L0.588313 6.95228L6.95227 0.588315Z" fill="#1F2140" />
            </svg>

            <span class="menu-icon-text">Close</span>
          </button>
        </div>
        <div class="medil-section">
          <div *ngIf="isAuthenticated">
            <a *ngIf="isPlanner" routerLinkActive="ActiveLink" routerLink="/plan" (click)="OCmenu()">
              <div>
                <span>Planering</span>
              </div>
            </a>
            <a *ngIf="isPlanner" routerLinkActive="ActiveLink" routerLink="/dispatcher" (click)="OCmenu()">
              <div>
                <span>Dispatcher</span>
              </div>
            </a>
            <a *ngIf="isPlanner" routerLinkActive="ActiveLink" routerLink="/busmap" (click)="OCmenu()">
              <div>
                <span>Karta</span>
              </div>
            </a>
            <a *ngIf="isPlanner" routerLinkActive="ActiveLink" routerLink="/users" (click)="OCmenu()">
              <div>
                <span>Användare</span>
              </div>
            </a>
            <a *ngIf="isPlanner" routerLinkActive="ActiveLink" routerLink="/schedule" (click)="OCmenu()">
              <div>
                <span>Schema</span>
              </div>
            </a>
            <a *ngIf="isPlanner" routerLinkActive="ActiveLink" routerLink="/reports" (click)="OCmenu()">
              <div>
                <span>Rapporter</span>
              </div>
            </a>
            <a *ngIf="isPlanner" routerLinkActive="ActiveLink" routerLink="/administration" (click)="OCmenu()">
              <div>
                <span>Administration</span>
              </div>
            </a>


          </div>

          <div *ngIf="multiAirport" class="open-MenuItem" [ngClass]="airportstatus ? 'active' : 'an-active' " (click)="OCairport()">
            <div class="mobileMainMenuItem d-flex flex-row justify-content-start">
              <div class="p-item">
                <div class="menu-header">
                  <span>Change the airport</span>
                </div>
              </div>
              <div class="ms-auto p-item">
                <div class="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7">
                    <g fill="#2D6E78" fill-rule="evenodd">
                      <path d="M6 6.667l.509-.458L12 1.257 10.983 0 6 4.494 1.017 0 0 1.257 5.491 6.21z"></path>
                      <path d="M6 6.667l.509-.458L12 1.257 10.983 0 6 4.494 1.017 0 0 1.257 5.491 6.21z"></path>
                    </g>
                  </svg>
                </div>
              </div>
              <div style="clear:both; float:none;"></div>
            </div>
            <div *ngIf="airportstatus" class="mobileSubMenu">
              <a class="mobileSubMenuItem" (click)="OCmenu()">
                <div>
                  <span (click)="onAirportSelect('ARN')">Stockholm Arlanda</span>
                </div>
              </a>

              <a class="mobileSubMenuItem" (click)="OCmenu()">
                <div>
                  <span (click)="onAirportSelect('GOT')">Göteborg Landvetter</span>
                </div>
              </a>
            </div>
          </div>

        </div>
        <div class="bottom-section">
          <span class="user-action-name" matTooltip="{{currentUserName}}">
            {{currentUserName}}
          </span>
          <div class="user-action-link">
            <a class="user-action-a" *ngIf="!isAuthenticated" (click)="login()">Login</a>
            <a class="user-action-a" *ngIf="isAuthenticated" (click)="logout()">Logout</a>
          </div>
        </div>
      </div>
    </div>

  </mat-toolbar-row>
</mat-toolbar>
<audio #busHonk>
  <source src='../../../assets/busstransfer.wav' type="audio/x-wav">
</audio>
